import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["display"],
  _excluded2 = ["as", "children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { FLEX_RESET_STYLES } from './Flex.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledFlex = styled.div.withConfig({
  displayName: "Flex__StyledFlex",
  componentId: "sc-1slqn99-0"
})(props => {
  const _props$$cssStyles = props.$cssStyles,
    {
      display
    } = _props$$cssStyles,
    $cssStyles = _objectWithoutPropertiesLoose(_props$$cssStyles, _excluded);
  return Object.assign({}, FLEX_RESET_STYLES, {
    display: display || 'flex',
    textDecoration: 'inherit'
  }, $cssStyles);
});

/**
 * A layout container that implements the CSS Flexbox API.
 */
export const Flex = _ref => {
  let {
      as = 'div',
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledFlex, Object.assign({}, domProps, callbackProps, {
    as: as,
    $cssStyles: cssStyles,
    children: children
  }));
};